const management = {
	alert: {
		shutdown:
			"Shutting down a VPS shortly after it has started up may take longer than usual or may fail. If you wish to try shutting it down again, please click 'Shutdown' again until the action is successfully completed.",
	},
	config: {
		delete: "Delete VPS",
		title: "VPS Configuration",
		update: "Edit VPS",
	},
	general: {
		console: "Open Console",
		day: "day",
		days: "days",
		description: "Description",
		description_updated: "Your VPS description has been successfully updated.",
		hostname: "Hostname",
		name: "Name",
		relation: "Relation",
		title: "VPS Information",
		uptime: "Uptime",
	},
	notifications: {
		pending: "There are pending changes that will be applied after rebooting your machine.",
		update: "Processing changes for VPS <strong>{{name}}</strong>...",
		update_active:
			"The VPS configuration is currently updating. Please reboot your VPS before making further changes.",
	},
	pending_dialog: {
		description: "Below are the changes that can only be applied after rebooting your machine.",
		reboot_button: "Reboot",
		title: "Pending Changes",
	},
	snapshots: {
		available: "available",
		create: "Create Snapshot",
		description: "Snapshot information",
		dialog_create: {
			description: "Add a new snapshot.",
			expiring_date_first: "Clean up snapshot after",
			expiring_date_second: "days.",
			name_fail: "The name does not meet the requirements.",
			title: "Add Snapshot",
		},
		dialog_delete: {
			description:
				"Are you sure you want to permanently delete snapshot <strong>{{name}}</strong>?",
			title: "Delete Snapshot",
		},
		dialog_rollback: {
			description:
				"The VPS and all its data will be overwritten by snapshot <strong>{{name}}</strong>.",
			extra_options: {
				alert: "Selecting the above option will increase the available snapshots by one.",
				option_one: "Create a snapshot of the current state before proceeding.",
				title: "Extra Options",
			},
			title: "Rollback to Snapshot",
		},
		from: "from ",
		last_made: "Last created snapshot",
		not_available_button: "No snapshots available. Click here to set up snapshots",
		not_found: "No snapshots found.",
		title: "Snapshots",
	},
	ssh: {
		description:
			"Here are the SSH keys that were linked to this VPS during its creation. This is not real-time information.",
		expired: {
			description:
				"SSH keys are shown for up to 31 days after the VPS is created. After this period, they can only be obtained directly from the VPS to prevent misinformation.",
			title: "SSH keys are no longer displayed here.",
		},
		not_found: "No SSH keys found.",
	},
	title: "VPS Information",
};

export default management;
